import { cn } from '../../lib/cn.js'

export interface DurationProps {
  /** Minutes, as every duration on this platform is stored. */
  minutes: number | null | undefined
  empty?: string
  className?: string
}

/** 132 → "2 h 12 m". 60 → "1 h". 45 → "45 m". */
export function format(minutes: number): string {
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return `${m} m`
  if (m === 0) return `${h} h`
  return `${h} h ${m} m`
}

/**
 * A length of time, read rather than typed.
 *
 * The pair to `DurationInput`, and the same units: everything here is stored in
 * minutes. It exists because two screens would otherwise each decide for
 * themselves — a service is `60 min` and an attendance is `attended_minutes: 132`,
 * and written inline the first reads fine and the second reads as a number nobody
 * converts in their head.
 *
 * Kept as one function so the class record and the services table cannot disagree
 * about what 132 minutes is called.
 */
export function Duration({ minutes, empty = '–', className }: DurationProps) {
  if (minutes === null || minutes === undefined) {
    return <span className={cn('text-ink-muted', className)}>{empty}</span>
  }
  return <span className={cn('tabular-nums', className)}>{format(minutes)}</span>
}
